function debounce(fn, wait) {
    let t;
    return (...args) => {
        clearTimeout(t);
        t = setTimeout(() => fn.apply(this, args), wait);
    };
}

class SearchForm extends HTMLElement {
    constructor() {
        super();
        this.input = this.querySelector('input[type="search"]');
        this.submitButton = this.querySelector('button[type="submit"]');

        if (this.input) {
            this.input.form.addEventListener("reset", this.onFormReset.bind(this));
            this.input.addEventListener(
                "input",
                debounce((event) => {
                    this.onChange(event);
                }, 300).bind(this)
            );
        }
    }

    toggleSubmitButton() {
        const submitIsHidden = this.submitButton.classList.contains("hidden");
        if (this.input.value.length > 0 && submitIsHidden) {
            this.submitButton.classList.remove("hidden");
        } else if (this.input.value.length === 0 && !submitIsHidden) {
            this.submitButton.classList.add("hidden");
        }
    }
    onChange() {
        this.toggleSubmitButton();
    }

    shouldResetForm() {
        return !document.querySelector('[aria-selected="true"] a');
    }

    onFormReset(event) {
        // Prevent default so the form reset doesn't set the value gotten from the url on page load
        if (event) event.preventDefault();
        // Don't reset if the user has selected an element on the predictive search dropdown
        if (this.shouldResetForm()) {
            this.input.value = "";
            this.input.focus();
            this.toggleSubmitButton();
        }
    }
}

customElements.define("search-form", SearchForm);
